module.exports = __webpack_public_path__ + "media/stockholm/statue-ab1d083a.jpg";